var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop } from "vue-property-decorator";
import Common from "../../../common/common";
let KioskReports = class KioskReports extends Vue {
    constructor() {
        super(...arguments);
        this.perPage = 10;
        this.currentPage = 1;
        this.loaded = false;
        this.formIsSelected = false;
        this.filter = "";
        this.forms = [];
        this.isOpen = false;
        this.selected = [];
        this.fields = [];
        this.items = [];
    }
    get rows() {
        return this.items.length;
    }
    beforeCreate() { }
    rowClass(item, type) {
        if (!item || type !== 'row')
            return;
        if (this.selected.find((i) => { return i.Id === item.Id; }) != null)
            return 'row-selected';
    }
    selectAllRows(chk) {
        if (chk.checked)
            this.$refs.selectableTable.selectAllRows();
        else
            this.$refs.selectableTable.clearSelected();
        //if (chk.checked) this.selected = this.items;
        //else this.selected = [];
    }
    onPageChange() {
        this.selected = [];
        $('.b-table.b-table-select-multi input:checkbox').prop('checked', false);
    }
    mounted() {
        if (!Comm)
            return;
        Comm.send_json('/ContentWork/GetFirebaseData', { CompanyId: this.company, FormName: null }, (data) => {
            if (data && data != 'null') {
                this.forms = Object.keys(JSON.parse(data));
                this.loaded = true;
                Common.hideLoader();
                if (this.forms.length > 0) {
                    this.currentForm = this.forms[0];
                    $(".selection").html(this.currentForm);
                    this.formSelected();
                }
            }
        });
    }
    deleteEntry() {
        let ids = this.selected.map((i) => { return i.Id.toString(); });
        Common.postData('/ContentWork/DeleteFirebaseData', { CompanyId: this.company, FormName: this.currentForm, Ids: ids }, null).then((data) => {
            if (data.success) {
                for (var i = 0; i < this.selected.length; i++) {
                    let idx = this.items.findIndex((item) => { return item.Id == this.selected[i].Id; });
                    if (idx != -1)
                        this.items.splice(idx, 1);
                }
            }
        });
    }
    trashEntry() {
        if (this.selected.length > 0) {
            let paramModal = bootbox.confirm({
                "title": this.selected.length > 1 ? "Delete Selected Entries Permanently" : "Delete Selected Entry Permanently",
                size: "large",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'No',
                        className: 'btn-default'
                    }
                },
                "message": this.selected.length > 1 ? "Are you sure you want to delete the selected entries permanently?" : "Are you sure you want to delete the selected entry permanently?",
                callback: (result) => {
                    if (result) {
                        this.deleteEntry();
                    }
                }
            });
        }
    }
    deleteForm(formName) {
        //let ids = this.selected.map((i) => { return i.Id.toString(); });
        Common.postData('/ContentWork/DeleteFirebaseForm', { CompanyId: this.company, FormName: formName }, null).then((data) => {
            if (data.success) {
                for (var i = 0; i < this.forms.length; i++) {
                    if (this.forms[i] == formName) {
                        this.forms.splice(i, 1);
                    }
                }
            }
        });
        Comm.send_json('/ContentWork/GetFirebaseData', { CompanyId: this.company, FormName: null }, (data) => {
            if (data && data != 'null') {
                this.forms = Object.keys(JSON.parse(data));
                this.loaded = true;
                Common.hideLoader();
                if (this.forms.length > 0) {
                    this.currentForm = this.forms[0];
                    this.formSelected();
                    $(".selection").html(this.currentForm);
                }
            }
        });
    }
    trashForm(formName) {
        let paramModal = bootbox.confirm({
            "title": "Delete Selected Report Permanently",
            size: "large",
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'No',
                    className: 'btn-default'
                }
            },
            "message": "Are you sure you want to delete the selected report permanently?",
            callback: (result) => {
                if (result) {
                    this.deleteForm(formName);
                }
            }
        });
    }
    onRowSelected(items) {
        this.selected = items;
    }
    formSelected() {
        Comm.send_json('/ContentWork/GetFirebaseData', { CompanyId: this.company, FormName: this.currentForm }, (data) => {
            this.items = [];
            this.fields = [{ key: 'Id', label: 'Id', visible: false, sortable: true, thStyle: { width: '50px' } }];
            if (data && data != 'null') {
                var formEntries = JSON.parse(data);
                this.items = [];
                for (var i in formEntries) {
                    var entry = formEntries[i];
                    entry.Id = i.toString();
                    this.items.push(entry);
                }
                this.items.forEach(children => {
                    var entryColumnNames = Object.keys(children);
                    entryColumnNames.forEach((colName) => {
                        if (this.fields.find((f) => { return f.key === colName; }) == null)
                            this.fields.push({ key: colName, label: colName, visible: true, sortable: true });
                    });
                });
                this.formIsSelected = true;
                $(".selection").html(this.currentForm);
            }
            else {
                console.log('No results for this companyId');
            }
            Common.hideLoader();
        });
    }
    formSelected2(formSelected) {
        Comm.send_json('/ContentWork/GetFirebaseData', { CompanyId: this.company, FormName: formSelected }, (data) => {
            this.items = [];
            this.fields = [{ key: 'Id', label: 'Id', visible: false, sortable: true, thStyle: { width: '50px' } }];
            if (data && data != 'null') {
                var formEntries = JSON.parse(data);
                this.items = [];
                for (var i in formEntries) {
                    var entry = formEntries[i];
                    entry.Id = i.toString();
                    this.items.push(entry);
                }
                this.items.forEach(children => {
                    var entryColumnNames = Object.keys(children);
                    entryColumnNames.forEach((colName) => {
                        if (this.fields.find((f) => { return f.key === colName; }) == null)
                            this.fields.push({ key: colName, label: colName, visible: true, sortable: true });
                    });
                });
                this.formIsSelected = true;
                this.currentForm = formSelected;
                $(".selection").html(this.currentForm);
            }
            else {
                console.log('No results for this companyId');
            }
            Common.hideLoader();
        });
    }
    printReport() {
        if (this.items.lenght == 0)
            return;
        window.print();
    }
};
__decorate([
    Prop(),
    __metadata("design:type", String)
], KioskReports.prototype, "company", void 0);
KioskReports = __decorate([
    Component
], KioskReports);
export default KioskReports;
